module.exports = __webpack_public_path__ + "img/feature-icon-1.b7ca05ee.svg";